import styled from 'styled-components'
import BottomSheetLayout from '../common/BottomSheetLayout'
import DatePicker from '../common/DatePicker'
import Text from '../../atoms/Text'

const TextWrapper = styled.div`
  margin-top: 16px;
`
const PickerWrapper = styled.div`
  margin-top: 28px;
`

const DateOfBirthBottomSheet = ({ $isOpen, onClose, onChangeBirth }) => {
  const handleDateSelect = (date) => {
    onChangeBirth(date);
    onClose();
  }

  return (
    <BottomSheetLayout $isOpen={$isOpen} onClose={onClose}>
      <>
        <TextWrapper>
          <Text variant="headline2" weight="bold">생년월일을 선택해주세요.</Text>
        </TextWrapper>
        <PickerWrapper>
         <DatePicker 
          initialDate={new Date()}
          onDateSelect={handleDateSelect}/>
        </PickerWrapper>
      </>
    </BottomSheetLayout>
  )
}

export default DateOfBirthBottomSheet
